import React, { useEffect, useState } from 'react';
import axios from 'axios';
import LoadingSpinner from './LoadingSpinner';

const GmaxPokemon = () => {
    const [gmaxPokemon, setGmaxPokemon] = useState([]);
    const [selectedPokemon, setSelectedPokemon] = useState(null);
    const [showShiny, setShowShiny] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchPokemon = async () => {
            try {
                const res = await axios.get('https://tyradex.vercel.app/api/v1/pokemon');
                const gmaxList = res.data.filter(pokemon => pokemon.sprites.gmax);
                setGmaxPokemon(gmaxList);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching the Pokémon data:', error);
            }
        };

        fetchPokemon();
    }, []);

    const handleImageClick = (pokemon) => {
        setSelectedPokemon(pokemon);
        setShowShiny(false); 
    };

    const handleCloseModal = () => {
        setSelectedPokemon(null);
    };

    const toggleShiny = () => {
        setShowShiny(!showShiny);
    };

    if (gmaxPokemon.length === 0) return <LoadingSpinner/>;

    return (
        <div className="gmaxpokemon">
            <ul>
                {gmaxPokemon.map(pokemon => (
                    <li key={pokemon.pokedex_id} className="pokemoncard">
                        <img 
                            src={pokemon.sprites.gmax.regular} 
                            alt={pokemon.name.fr} 
                        />
                        <div className="infos" onClick={() => handleImageClick(pokemon)}>
                            <h2>{pokemon.name.fr} Gigamax</h2>
                        </div>
                    </li>
                ))}
            </ul>

            {selectedPokemon && (
                <div className="modal" onClick={handleCloseModal}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <img 
                            src={showShiny ? selectedPokemon.sprites.gmax.shiny : selectedPokemon.sprites.gmax.regular} 
                            alt={selectedPokemon.name.fr} 
                        />
                        <button onClick={toggleShiny}>
                            {showShiny ? 'Regular' : 'Shiny'}
                        </button>
                        <button onClick={handleCloseModal}>Fermer</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GmaxPokemon;

